var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.className},[_c('svg',{attrs:{"version":"1.1","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":_vm.path}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }